import styled from 'styled-components'

export const Styled = {
  Wrapper: styled.div`
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr;

    @media screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `,
  Invisible: styled.div`
    display: none;
  `,
  InfoBanner: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    color: #86F9AC;
    border-radius: 12px;
    border: 1.5px solid #86F9AC;
    background: #0B50DA;
    padding: ${props => (props.visible ? '20px' : 0)};
    margin-bottom:  ${props => (props.visible ? '20px' : 0)};
    margin-top: ${props => (props.visible ? '40px' : 0)};
    opacity: ${props => (props.visible ? 1 : 0)};
    height: ${props => (props.visible ? '100%' : '0')};
    transition: all 0.3s ease-out;

    p {
      font-feature-settings: 'salt' on;
      font-family: Source Sans Pro;
      font-size: 18px;
      font-weight: 400;
      line-height: 120%;
      
      span {
        font-style: italic;
      }
    }
    `,
}

